<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader @custom-event="getToken"></cnHeader>
		<div class="page_content">
			
			<!--全部评论-开始-->
			<el-dialog
			  title="评论"
			  :visible.sync="commentsDialog"
			  :destroy-on-close="true"
			  width="50%">
			  <div class="starlist_group">
			  	<div class="item" v-for="(item, index) in commentsList" :key="index">
			  		<div class="ud_star">
			  			<div class="ud">
			  				<h3>{{item.NickName}}</h3>
			  				<p class="date">发布于 {{item.PostDate}}</p>
			  			</div>
			  			<div class="star_group">
			  				<div :class="getListStarClass(item.Star)"></div>
			  			</div>
			  		</div>
			  		<div class="u_post" v-html="item.Content">
			  		</div>
			  		<div class="op_reply" v-if="item.Reply !=''">
			  			<h3>管理员回复：</h3>
			  			<div v-html="item.Reply"></div>
			  		</div>
			  	</div>
			  </div>
			</el-dialog>
			<!--全部评论-结束-->
			
			<!--全部图片-开始-->
			<el-dialog
			  title="图库"
			  :visible.sync="gallerysDialog"
			  :fullscreen="true"
			  custom-class="gallerysDialog"
			  >
			  <div class="gallerys_box" v-if="Gallerys.length>0">
				  <div class="left_items">
					  <div class="thumb">
					  	<ul>
					  		<li class="selected" v-if="index == galleryIndex" v-for="(item, index) in Gallerys" :key="index" @click="changeGallery(index)">
					  			<img :src="item.Picture" />
					  		</li>
					  		<li v-else @click="changeGallery(index)">
					  			<img :src="item.Picture" />
					  		</li>
					  	</ul>
					  </div>
				  </div>
				  <div class="right_preview">
					  <transition name="fade"><img v-if="showImage" :src="Gallerys[galleryIndex].Picture" /></transition>
				  </div>
			  </div>
			</el-dialog>
			<!--全部图片-结束-->
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/cn">首页</a><span class="space">/</span><a href="/cn/product">旅游套餐</a><span class="space">/</span>{{productDetail.Title}}
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--图片区-开始-->
			<div class="pub_div dp_picture_box">
				<div class="focus_box">
					<div class="view_more" @click.stop="viewAllPictures()">更多图片</div>
					<el-image
					style="width: 100%; height: 372px; border-radius: 8px;"
					:src="focusPicture"
					fit="cover"></el-image>
				</div>
				<div class="other_box">
					<div class="item" v-for="(item, index) in otherPictureList" :key="index">
						<el-image
						style="width: 100%; height: 180px; border-radius: 8px;"
						:src="item"
						fit="cover"></el-image>
					</div>
				</div>
			</div>
			<!--图片区-结束-->
			
			<!--Tab控制栏-开始-->
			<div class="sticky_box">
			<div class="pub_div tab_ctroller_box">
				
				<div class="tab_box">
					
					<el-tabs v-model="activeTab" stretch @tab-click="handleTabClick">
						<el-tab-pane v-for="item in tabList" :key="item.id" :label="item.label" :name="item.id" />
					</el-tabs>
					
				</div>
				
				<div class="favorite_box">
					<span v-if="CollectionState == 0" @click="collectionHandle(1)">收藏</span>
					<span class="selected" v-if="CollectionState == 1" @click="collectionHandle(0)">取消收藏</span>
				</div>
				
			</div>
			</div>
			<!--Tab控制栏-结束-->
			
			<!--基础信息-开始-->
			<div class="pub_div basic_information_box" id="tab1">
				
				<!--左侧-开始-->
				<div class="left_box">
					<h1>{{productDetail.Title}}</h1>
					<div class="ext_box">
						<span class="location">{{productDetail.Location}}</span>
						<span><b>{{productDetail.StrokeDays}}日游</b></span>
						<span>{{productDetail.Schedule}}</span>
					</div>
					<!--属性-开始-->
					<div class="attribute">
						<div class="tag valid">{{productDetail.ValidityDate}}</div>
						<div class="tag hotelplan">住宿方案 {{productDetail.HotelPlan}} 套</div>
						<div class="tag sale">折扣优惠</div>
					</div>
					<!--属性-结束-->
					<!--摘要-开始-->
					<div class="description" v-if="productDetail.Slogan != ''" v-html="productDetail.Slogan"></div>
					<!--摘要-结束-->
					
					<!--住宿方案-开始-->
					<div class="plan_box">
						<h3>请选择住宿方案</h3>
						<ul>
							<li v-for="(item, index) in planList" :key="index">
								<div class="type_title">
									<h4>{{item.Title}}</h4>
									<div class="hotel" v-for="(x, b) in item.Hotels" :key="b">
										<h5>{{x.HotelName}} {{x.RoomType}}</h5>
										<!-- <h5>{{x.RoomType}}<span>{{x.Nights}}晚</span></h5> -->
									</div>
								</div>
								<div class="price_box">
									<div class="discount">${{item.ShowPrice}}<em>起</em></div>
									<div class="tips">该价格已包含度假村费</div>
								</div>
								<div class="btn_box" @click="booking(item.PlanId)">预订</div>
							</li>
						</ul>
					</div>
					<!--住宿方案-结束-->
				</div>
				<!--左侧-结束-->
				
				<!--评论区-开始-->
				<div class="right_box">
					<!-- <cnPinglun :Comments="productDetail.Comments" @custom-event="viewAllComments"></cnPinglun> -->
										
					<!--友情提醒-开始-->
					<div class="prompt_box">
						<div class="icon djc"></div>
						<div class="text">
							<h5>什么是度假村费？</h5>
							<p>美国夏威夷辖区内所有酒店用游客强制收取的服务费用。</p>
						</div>
					</div>
					<!--友情提醒-结束-->
				</div>
				<!--评论区-结束-->
				
			</div>			
			<!--基础信息-结束-->
			
			<!--详细内容等富文本内容-开始-->
			<div class="html_content_box">
				<div class="html_section" id="tab2">
					<div class="title">
						行程介绍
						<div class="download" v-if="productDetail.TripFile !=''"><a :href="productDetail.TripFile" target="_blank">下载行程单</a></div>
					</div>
					<div class="hs_content" v-html="productContent"></div>
				</div>
				<div class="html_section" id="tab3">
					<div class="title">包含景点</div>
					<div class="hs_content">
						<div class="recreation_box">
							<div class="item" v-for="(item, index) in productDetail.Recreations" :key="index">
								<a :href="'/cn/recreation/detail?Id='+item.RecreationId" target="_blank" :title="item.Title">
									<img :src="item.Picture" />
									<div class="text">{{truncatedMessage(item.Title,25)}}</div>
								</a>
							</div>
						</div>
					</div>
				</div>
				<div class="html_section" id="tab4">
					<div class="title">费用明细</div>
					<div class="hs_content" v-html="productDetail.PriceTip">
						
					</div>
				</div>
				<div class="html_section" id="tab5">
					<div class="title">预订须知</div>
					<div class="hs_content" v-html="productDetail.Notice">
						
					</div>
				</div>
			</div>
			<!--详细内容等富文本内容-结束-->
			
		</div>
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	const TAB_OFFSET_TOP = 80;	//块内容距顶部距离
	
	import {
		getProductDetail,
		checkToken,
		collection,
		getAllComments,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnFooter from '@/components/cn_footer.vue'
	import cnPinglun from '@/components/cn_pinglun.vue'
	export default {
		name: 'CN_ProductDetail',
		mixins: [mixin],
		components: {
			cnHeader,
			cnFooter,
			cnPinglun,
		},
		data() {
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now()+(1 * 24 * 60 * 60 * 1000) || time.getTime() > Date.now()+(365 * 24 * 60 * 60 * 1000)
					},
				},
				chooseDay: Date.now()+2 * 24 * 60 * 60 * 1000,
				
				Id: '', //套餐Id
				planId: '',	//住宿方案
				fullscreenLoading: true, //loading状态
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				productDetail: [], //详情
				Gallerys:[],		//图片集
				pictureIndex: 0,	//大图索引,
				galleryIndex: 0,	//大图索引,
				showImage: false,	//大图显示状态
				CollectionState:'',	//收藏状态
				clickLock: false,	//操作锁定状态,
				commentsDialog: false,	//全部评论展示状态
				commentsList:[],		//全部评论数据
				gallerysDialog: false,	//图库展示状态
				
				planList: [],	//住宿方案列表
				
				productContent: '',	//行程介绍富文本
				
				//图片
				focusPicture: '',		//首图
				otherPictureList: [],	//后四张图
				
				// Tab标题栏相关
				activeTab: "tab1",
				isAutoScrolling: false,
				scrollTimer: null,
				tabList: [{
						id: "tab1",
						label: "套餐信息",
					},
					{
						id: "tab2",
						label: "行程介绍",
					},
					{
						id: "tab3",
						label: "包含景点",
					},
					{
						id: "tab4",
						label: "费用明细",
					},
					{
						id: "tab5",
						label: "预订须知",
					},
				],
			}
		},
		computed: {
			limitedGallerys() {
				return this.productDetail.Gallerys.slice(0, 5); // 只取前5个元素
			}
		},
		mounted() {
			/*Tab标题栏使用*/
			this.$nextTick(() => {
				this.updateActiveTab();
				window.addEventListener("scroll", this.handleScroll, {
					passive: true
				});
				window.addEventListener("resize", this.handleScroll);
			});				
		},
		beforeDestroy() {
			/*Tab标题栏使用*/
			window.removeEventListener("scroll", this.handleScroll);
			window.removeEventListener("resize", this.handleScroll);
			if (this.scrollTimer) {
				clearTimeout(this.scrollTimer);
			}
		},
		created() {
			// 模拟获取url参数
			this.Id = this.$route.query.Id
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
				}
				this.getData()
			},
			
			//获取数据
			async getData() { const { data: res } = await getProductDetail(this.language, this.Id, this.formattedDate(this.chooseDay), this.terminal, this.token)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.productDetail = res.data
					document.title = this.productDetail.Title + ' | 旅游套餐 - 檀岛旅游 (简体中文)'
					this.Gallerys = res.data.Gallerys
					this.showImage = true
					this.CollectionState = this.productDetail.CollectionState
					this.planList = this.productDetail.Plans
										
					//热词替换
					this.productContent = this.patchReplace(
					this.productDetail.RecreationHotKeywords,
					this.productDetail.Content,
					'/cn/recreation/detail?Id=')
					
					//新增图片解析
					this.pictureFilter(this.Gallerys)
					
				} else {
					this.$message.error(res.errmsg);
				}
			},
			
			//切换图片
			changeGallery(i)
			{
				if(this.galleryIndex != i)
				{
					this.showImage = false
					this.galleryIndex = i
					setTimeout(() => {
						this.showImage = true
					}, 100)
				}
			},
			
			//收藏操作
			async collectionHandle(action)
			{
				if(this.clickLock)
				{
					return
				}
				this.clickLock = true	//锁住按钮
				if(this.loginStatus)
				{
					let params={
						Token:this.token,
						Terminal:this.terminal,
						ColumnId:0,
						Id:this.Id,
						Action:action
					}
					const { data: res } = await collection(params)
					if (res.errcode === 0) {						
						this.CollectionState = action
						this.$message({
						  message: '操作成功',
						  type: 'success'
						});
					} else {
						this.$message.error(res.errmsg);
					}
				}
				else
				{
					this.$router.push({
						path: '/cn/user/login?ReturnUrl=' + encodeURIComponent(window.location.href)
					})
				}
				this.clickLock = false	//解锁按钮
			},
			
			//图片解析处理
			pictureFilter(gallerys)
			{
				if(gallerys.length>0)
				{
					this.focusPicture = gallerys[0].Picture
					
					gallerys.forEach((item, index) => {
						if(index > 0 && index < 5)
						{
							this.otherPictureList.push(gallerys[index].Picture)
						}
					})
				}
			},
			
			//立即预订
			booking(planId)
			{
				// this.$router.push({
				// 	path: '/cn/product/booking?Id='+this.Id+'&PlanId=' + this.planId+'&BookingDate='+this.formattedDate(this.chooseDay)
				// })
				location.href = '/cn/product/booking?Id='+this.Id+'&PlanId=' + planId+'&BookingDate='+this.formattedDate(this.chooseDay)
			},
			
			//查看全部评论
			viewAllComments()
			{
				this.getAllComments()
			},
			
			//获取全部评论数据
			async getAllComments()
			{
				this.fullscreenLoading = true
				let params={
					PageIndex: 1,
					ColumnId: 0,
					DataId: this.Id,
				}				
				const { data: res } = await getAllComments(params.PageIndex, params.ColumnId, params.DataId)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.commentsList = res.data.DataList
					this.commentsDialog = true
				} else {
					this.$message.error(res.errmsg);
				}
			},
			
			//查看全部图片
			viewAllPictures()
			{
				this.galleryIndex = 0
				this.gallerysDialog = true
			},
			
			/*以下为Tab栏使用的方法*/
			handleTabClick(tab) {
				this.scrollToContent(tab.name);
			},
			handleScroll() {
				if (this.isAutoScrolling) {
					return;
				}
				this.updateActiveTab();
			},
			scrollToContent(id) {
				const target = document.getElementById(id);
				if (!target) {
					return;
				}
			
				this.activeTab = id;
				this.isAutoScrolling = true;
				window.scrollTo({
					top: target.offsetTop - TAB_OFFSET_TOP,
					behavior: "smooth",
				});
			
				if (this.scrollTimer) {
					clearTimeout(this.scrollTimer);
				}
				this.scrollTimer = setTimeout(() => {
					this.isAutoScrolling = false;
					this.updateActiveTab();
				}, 500);
			},
			updateActiveTab() {
				const threshold = TAB_OFFSET_TOP + 20;
				let currentId = this.tabList[0].id;
			
				this.tabList.forEach((item) => {
					const element = document.getElementById(item.id);
					if (element && element.getBoundingClientRect().top <= threshold) {
						currentId = item.id;
					}
				});
			
				if (
					window.innerHeight + window.pageYOffset >=
					document.documentElement.scrollHeight - 10
				) {
					currentId = this.tabList[this.tabList.length - 1].id;
				}
			
				this.activeTab = currentId;
			},

		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		/*住宿方案*/
		.plan_box {
			margin-top: 30px;
			
			h3 {
				font-size: 18px;
				font-weight: 500;
			}
			
			ul {
				margin-top: 20px;
			}
			li {
				background-color: #fff;
				border: #E4E4E4 solid 2px;
				border-radius: 8px;
				padding: 12px;
				margin: 10px 0;
				-webkit-transition: all .3s ease;
				display: flex;
				justify-content: space-between;
				align-items: center;
				background-color: #FAFFF9;
				
				.type_title {
					width: 60%;
					h4 {
						font-size: 16px;
						font-weight: 500;
					}
					
					.hotel {
						margin-top: 5px;
						
						h5 {
							font-size: 13px;
							font-weight: 400;
						}
					}
				}
				
				.price_box {
					width: 20%;
					text-align: right;
					
					.discount {
						font-size: 24px;
						font-weight: 500;
						
						em {
							display: inline-block;
							font-size: 13px;
							color: #333;
							vertical-align: middle;
							margin-left: 4px;
							font-size: 400;
						}
					}
					.tips {
						margin-top: 6px;
						font-size: 12px;
						font-weight: 500;
						line-height: 100%;
						color: #3D7856;
						text-align: right;
					}
				}
				
				.btn_box {
					width: 80px;
					height: 40px;
					line-height: 40px;
					background-color: #3D7856;
					border-radius: 20px;
					color: #fff;
					font-size: 15px;
					text-align: center;
					cursor: pointer;
					-webkit-transition: all .3s ease;
				}
				.btn_box:hover {
					background-color: #000;
				}
			}
			li:hover {
				border: #3D7856 solid 2px;
				background-color: #FAFFF9;
			}
		}
		
		/*行程单*/
		.download {
			margin-top: 30px;
			
			a {
				margin: 0 auto;
				display: inline-block;
				height: 36px;
				line-height: 36px;
				border-radius: 18px;
				padding: 0 20px;
				font-size: 14px;
				background-color: #3D7856;
				color: #fff;
				-webkit-transition: all .3s ease;
			}
			a:hover {
				background-color: #000;
			}
		}

		/*包含景点*/
		.recreation_box {
			display: flex;
			justify-content: left;
			flex-wrap: wrap;

			.item {
				width: 206px;
				position: relative;
				overflow: hidden;
				background: #fff;
				box-shadow: 0 0 5px #ddd;
				border-radius: 8px;
				cursor: pointer;
				-webkit-transition: all .3s ease;
				margin: 0 22px 20px 2px;

				img {
					width: 100%;
					height: 138px;
					display: block;
					vertical-align: middle;
					border-top-left-radius: 8px;
					border-top-right-radius: 8px;
				}

				.text {
					padding: 10px;
					font-size: 13px;
					line-height: 140%;
					color: #111;
				}
			}
			.item:nth-child(n+5) {
				margin-right: 0;
			}

			.item:hover {
				.text {
					text-decoration: underline;
					color: #008768;
				}
			}
		}

		/*推荐套餐*/
		.recommend_box {
			display: flex;
			justify-content: left;
			flex-wrap: wrap;
			padding: 5px 0px;
			
			.carouse_box {
				position: relative;
				overflow: hidden;
				width: 100%;
			}

			/*列表*/
			.items {
				display: flex;
				transition: transform 0.3s ease;
				box-sizing: border-box;
				padding: 10px 0;

				.item {
					width: 286px;
					height: 273px;
					margin: 0 12px;
					border-radius: 10px;
					-webkit-transition: all .5s ease;

					.picture {
						position: relative;
						cursor: pointer !important;

						.days_tag {
							position: absolute;
							z-index: 1000;
							left: 10px;
							top: 14px;
							
							span {
								display: inline-block;
								vertical-align: middle;
								margin: 0 5px;
								height: 24px;
								line-height: 24px;
								padding: 0 10px;
								background: #000;
								font-size: 12px;
								color: #fff;
								border-radius: 12px;
							}
							
							.arr_0 {
								background-color: #11c855;
								color: #fff;
							}
							.arr_1 {
								background-color: #00a43d;
								color: #fff;
							}
							.arr_2 {
								background-color: #ff6600;
								color: #fff;
							}
						}

						img {
							width: 100%;
							height: 190px;
							border-radius: 10px;
							display: block;
							cursor: pointer !important;
							-webkit-transition: all .25s ease;
						}
					}

					.information {
						padding: 0 10px;

						.title {
							margin-top: 8px;
							font-size: 13px;
							font-weight: 500;
							line-height: 150%;
							cursor: pointer !important;
						}

						.plan_price {
							margin-top: 2px;
							display: flex;
							justify-content: space-between;
							align-items: center;
							font-size: 13px;
							color: #333;

							.plan {
								padding-left: 20px;
								height: 20px;
								line-height: 20px;
								background-image: url(@/assets/images/icons/hotel.png);
								background-position: left center;
								background-repeat: no-repeat;
								background-size: 14px 16px;

								span {
									font-weight: 500;
									display: inline-block;
									vertical-align: bottom;
									margin: 0 4px;
								}
							}

							.price {
								font-size: 12px;
								color: #666;

								span {
									font-size: 16px;
									font-weight: 500;
									color: #000;
									display: inline-block;
									vertical-align: top;
									margin-right: 4px;
								}
							}
						}
					}

				}

				.item:first-child {
					margin-left: 0;
				}

				.item:hover {
					background: #fff;
					box-shadow: 0 0 10px #dedede;
					margin-top: -5px;

					img {
						border-bottom-left-radius: 0;
						border-bottom-right-radius: 0;
					}

					.title {
						text-decoration: underline;
					}
				}
			}

			/*指示器*/
			.indicator {
				width: 100px;
				height: 32px;
				margin: 30px auto;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.arr {
					width: 32px;
					height: 32px;
					background-position: center;
					background-repeat: no-repeat;
					background-size: 7px 12px;
					background-color: #fff;
					border-radius: 16px;
					border: #F4F4F4 solid 1px;
					cursor: pointer !important;
					box-shadow: 0 0 5px #eee;
					-webkit-transition: all .2s ease;
				}

				.arr:hover {
					box-shadow: 0 0 5px #DEF8FF;
					background-color: #f0f7ff;
				}

				.left {
					background-image: url(@/assets/images/icons/arrow_left.png);
				}

				.right {
					background-image: url(@/assets/images/icons/arrow_right.png);
				}

				.l_gray {
					background-image: url(@/assets/images/icons/arrow_left_gray.png);
				}

				.l_gray:hover {
					background-color: #fff;
					box-shadow: 0 0 5px #eee;
				}

				.r_gray {
					background-image: url(@/assets/images/icons/arrow_right_gray.png);
				}

				.r_gray:hover {
					background-color: #fff;
					box-shadow: 0 0 5px #eee;
				}
			}
		}
		
	}
</style>